import { Dialog, DialogTitle, Button, DialogContent, DialogActions, TextField, Checkbox, TableBody, Table, TableContainer, TableHead, TableRow, TableCell, Grid, MenuItem } from "@mui/material"
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { LabelTag, StrongTag } from "../Common/Components";
import Swal from "sweetalert2";
import axios from "axios";
import { useEffect } from "react";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const PendingItem = ({ open, handleClose, formData = {}, pendingItems=[], id = null, onPendingItemUpdate = () => {} }) => {
    const [btnLoading, setBtnLoading] = useState(false);
    const [deliveryQuantityErrors, setDeliveryQuantityErrors] = useState({});

    const [data, setData] = useState({
        expectedDeliveryDate: null,
        isPartiallyDelivered: false,
        deliveredQuantity: ""
    });

    const [updatedPendingItems, setUpdatedPendingItems] = useState([])

    const [customTime, setCustomTime] = useState({ hour: "", minute: "00", meridian: "AM", timeSession: "" });
    const hours = ["12", "06", "07", "08", "09", "10", "11", "01", "02", "03", "04", "05"];
    const minutes = ["00", "15", "30", "45"];
    const meridians = ["AM", "PM"];
    const session = ["B4", "Aft"];

    useEffect(() =>{
        if(pendingItems?.length > 0){
            let count = 0
            pendingItems.forEach(item => {
                const deliveredQty = item.order_item_me_flag === "ME"
                ? item.order_item_me_uom_value_delivered
                : item.order_item_pieces_delivered;
                if(parseFloat(deliveredQty || 0) > 0){
                    count++
                }
            })
            if(count > 0){
                setData({...data, isPartiallyDelivered: true})
            }
            setData({...data, expectedDeliveryDate: pendingItems[0]?.order_item_me_expected_delivery_date?.split("T")[0] || pendingItems[0]?.order_item_expected_delivery_date?.split("T")[0] || null})
            if(pendingItems[0]?.order_item_delivery_time || pendingItems[0]?.order_item_me_delivery_time){
                const [timePart, meridian] = pendingItems[0].order_item_delivery_time?.split(" ") || pendingItems[0].order_item_me_delivery_time?.split(" ");
                const [hour, minute] = timePart?.split(".");
                setCustomTime({
                    hour: hour?.padStart(2, "0") || "12",
                    minute: minute?.padStart(2, "0") || "00",
                    meridian: meridian || "AM",
                    timeSession: pendingItems[0]?.order_item_delivery_session || pendingItems[0]?.order_item_me_delivery_session || "",
                });
            }
            setUpdatedPendingItems(pendingItems)
        }
    },[pendingItems])


    const onSubmit = async (e) => {
        e.preventDefault();
        if (Object.values(deliveryQuantityErrors).some(err => err)) {
            Swal.fire({
                text: "Please fix delivery quantity errors before submitting.",
                icon: "warning",
            });
            return;
        }
        setBtnLoading(true)
        let hour = parseInt(customTime.hour || "0");
        const isPM = customTime.meridian === "PM";
    
        if (isPM && hour !== 12) hour += 12;
        if (!isPM && hour === 12) hour = 0;

        const payload = {
            expected_delivery_date : data.expectedDeliveryDate,
            isPartiallyDelivered: data.isPartiallyDelivered,
            order_delivery_time: `${customTime.hour}.${customTime.minute} ${customTime.meridian}`,
            order_delivery_session : customTime.timeSession || "",
            pendingItems: updatedPendingItems
        }

        try {
            const url = `${API_BASE_URL}bulk-update-item-delivery-details/${id}`;
            const response = await axios.patch(
                url,
                payload,
                {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                }
            );

            if (response.status === 200) {
                Swal.fire({
                    text: "Delivery details updated successfully",
                    icon: "success",
                    timer: 1500,
                });
                resetForm()
                onPendingItemUpdate();
                setBtnLoading(false)
            }
            } catch (error) {
                Swal.fire({
                    text: error.response?.data || "Failed to update delivery details",
                    icon: "error",
                });
                setBtnLoading(false)
            } finally {
                setBtnLoading(false)
            }
    }

    const resetForm = () => {
        setData({
            expectedDeliveryDate: null,
            isPartiallyDelivered: false,
            deliveredQuantity: ""
        })
        setUpdatedPendingItems([])
        setDeliveryQuantityErrors({})
        setCustomTime({ hour: "", minute: "00", meridian: "AM", timeSession: "" })
        handleClose()
    }

    const handlePendingCountChange = (rowIndex, fieldName, value) => {
        setUpdatedPendingItems((prevRows) =>
            prevRows.map((row, index) => {
                if (index === rowIndex) {
                    const totalQuantity = parseFloat(
                        row.order_item_flag === "DT"
                            ? row.order_item_pieces
                            : row.order_item_me_uom_value
                        || 0
                    );
                    const enteredQty = parseFloat(value || 0);
                    let error = '';
                    if (enteredQty > totalQuantity) {
                        error = `Delivered quantity cannot exceed total quantity (${totalQuantity})`;
                    } else if (enteredQty < 0) {
                        error = 'Delivered quantity cannot be negative';
                    }
                    setDeliveryQuantityErrors(prev => ({ ...prev, [row._id]: error }));
                    return { ...row, [fieldName]: value };
                }
                return row;
            })
        );
    };

    return(
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg" className="GeneralModal">
            <DialogTitle className="space-between">
                Update Delivery Status
                <Button 
                    onClick={() => {
                        handleClose()
                        resetForm()
                    }} 
                    className="btn"
                >
                    X
                </Button>
            </DialogTitle>
            <form onSubmit={(e) => onSubmit(e)}>
            <DialogContent>
                <Grid container columnSpacing={2}>
                        <Grid item md={4}>
                            <TextField
                                label="Expected Delivery Date"
                                required
                                type="date"
                                fullWidth
                                value={data.expectedDeliveryDate}
                                onChange={(e) => setData(prev => ({
                                    ...prev,
                                    expectedDeliveryDate: e.target.value
                                }))}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ min: new Date().toISOString().split('T')[0] }}
                            />
                        </Grid>
                        <Grid item md={4} className="d-flex align-items-end gap-2">
                        <TextField focused required fullWidth select label="Hour" value={customTime.hour} onChange={e => setCustomTime(prev => ({ ...prev, hour: e.target.value }))} variant="standard">
                            {hours.map(h => (
                            <MenuItem key={h} value={h}>
                                {h}
                            </MenuItem>
                            ))}
                        </TextField>
                        <TextField required fullWidth select label="Minute" value={customTime.minute} onChange={e => setCustomTime(prev => ({ ...prev, minute: e.target.value }))} variant="standard">
                            {minutes.map(m => (
                            <MenuItem key={m} value={m}>
                                {m}
                            </MenuItem>
                            ))}
                        </TextField>
                        <TextField required select fullWidth label="AM/PM" value={customTime.meridian} onChange={e => setCustomTime(prev => ({ ...prev, meridian: e.target.value }))} variant="standard">
                            {meridians.map(m => (
                            <MenuItem key={m} value={m}>
                                {m}
                            </MenuItem>
                            ))}
                        </TextField>
                        <TextField focused select fullWidth label="Before/After" value={customTime?.timeSession} onChange={e => setCustomTime(prev => ({ ...prev, timeSession: e.target.value || "" }))} variant="standard">
                            <MenuItem value="">Select</MenuItem>
                            {session.map(m => (
                            <MenuItem key={m} value={m}>
                                {m}
                            </MenuItem>
                            ))}
                        </TextField>
                        </Grid>
                        <Grid md={4} ali>
                            <LabelTag className="d-flex align-items-center justify-content-end">
                                <Checkbox
                                    checked={data.isPartiallyDelivered}
                                    onChange={(e) => {
                                        setData(prev => ({
                                            ...prev,
                                            isPartiallyDelivered: e.target.checked,
                                            deliveredQuantity: e.target.checked ? prev.deliveredQuantity : '0'
                                        }));
                                    }}
                                    sx={{ color: '#d22530', '&.Mui-checked': { color: '#d22530' } }}
                                />
                                <span>Partially Delivered</span>
                            </LabelTag>
                        </Grid>
                </Grid>
                <TableContainer sx={{ maxHeight: "60vh", marginTop: 2 }}>
                    <Table className="bgGrey stripedTable" aria-label="Order table">
                    <TableHead sx={{ position: 'sticky', top: 0, zIndex: 20, backgroundColor: 'lightgray' }}>
                        <TableRow>
                        <TableCell align="left" width="70px">
                            S No
                        </TableCell>
                        <TableCell align="left">Inventory ID</TableCell>
                        <TableCell align="left">Description</TableCell>
                        <TableCell align="center">Total Pieces</TableCell>
                        {data.isPartiallyDelivered ? 
                            <TableCell align="center" title="Quantity">
                                Pending Pieces
                            </TableCell>      
                        : null }                     
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {updatedPendingItems?.map((item, index) => (
                            <TableRow key={item._id}>
                                <TableCell align="left">{item.sNo}</TableCell>
                                <TableCell align="left" sx={{width:"9vw"}}>
                                    <StrongTag>
                                    {item.order_item_code || item.order_item_me_code}
                                    </StrongTag>
                                </TableCell>
                                <TableCell align="left">{ item.order_item_description || item.order_item_me_description}</TableCell>
                                <TableCell align="center" sx={{width:"6vw"}}>{item.order_item_pieces || item.order_item_me_uom_value}</TableCell>
                                {data.isPartiallyDelivered ? 
                                    <TableCell align="center" sx={{width:"9vw"}}>
                                        <TextField 
                                            id="deliveredQuantity"
                                            name="deliveredQuantity"
                                            type="number"
                                            value={item.order_item_pieces_delivered || item.order_item_me_uom_value_delivered}
                                            onChange={(e) => handlePendingCountChange(index, item?.order_item_flag === "DT" ?"order_item_pieces_delivered" : "order_item_me_uom_value_delivered", e.target.value)}
                                            size="small"
                                            margin="none"
                                            error={!!deliveryQuantityErrors[item._id]}
                                            helperText={deliveryQuantityErrors[item._id] || ''}
                                        />
                                    </TableCell>
                                : null }
                            </TableRow>
                        ))
                    }
                    </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions className="d-flex justify-content-end">
                <Button className="btn primary-btn mb-1" type="submit" disabled={btnLoading}>
                    {btnLoading ? <Spinner animation="border" size="sm" /> : "Submit"}
                </Button>
            </DialogActions>
            </form>
        </Dialog>
    )
}

export default PendingItem